import { Input, Injector, Component, OnChanges, TemplateRef, SimpleChanges } from '@angular/core';

import { ISnComponentOrTemplateConfig } from '@lib/common/interfaces';
import { SnComponentOrTemplate } from '@lib/common/types';

import { SN_NAVBAR_DATA } from '../../providers';

@Component({
  selector: 'sn-layout-navbar-secondary',
  templateUrl: './layout-navbar-secondary.component.html',
  styleUrls: ['./layout-navbar-secondary.component.scss'],
  host: { class: 'sn-layout-navbar__secondary' },
})
export class SnLayoutNavbarSecondaryComponent implements OnChanges {
  @Input()
  public componentOrTemplate: SnComponentOrTemplate;

  @Input()
  public config: ISnComponentOrTemplateConfig;

  @Input()
  public width: number;

  public isTemplateRef = false;

  public templateContext: Object;
  public componentInjector: Injector;

  constructor(private readonly _injector: Injector) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ('componentOrTemplate' in changes) {
      this._onComponentOrTemplateChange(changes.componentOrTemplate.currentValue);
    }

    if ('config' in changes) {
      this._onConfigChange(changes.config.currentValue || {});
    }
  }

  private _onComponentOrTemplateChange(componentOrTemplate: SnComponentOrTemplate): void {
    this.isTemplateRef = componentOrTemplate instanceof TemplateRef;
  }

  private _onConfigChange(config: ISnComponentOrTemplateConfig): void {
    this.templateContext = { $implicit: config.data };

    const userInjector = config.viewContainerRef && config.viewContainerRef.injector;
    const providers = [{ provide: SN_NAVBAR_DATA, useValue: config.data }];

    this.componentInjector = Injector.create({
      providers,
      parent: userInjector || this._injector,
    });
  }
}
